<template>
  <div
    :class="[
      $style.icon,
      hasHover ? $style.hover : ''
    ]"
    class="mt-icon mt-icon-download"
  />
</template>

<script type="text/ecmascript-6">
export default {
  name: 'DownloadIcon',

  props: {
    hover: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      hasHover: false
    }
  },

  created () {
    this.hasHover = this.hover
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';
@import "mpl-css/lib/assets/global/icons/icons-colors";
$download-fill: encodeHexColor(map-get($colors, 'new-blue'));
@import "mpl-css/lib/assets/global/icons/icons-svg";
$downloadIcon: map-get($icons, 'download');
$download-fill: encodeHexColor(map-get($colors, 'new-blue')); // earlier blue
@import "mpl-css/lib/assets/global/icons/icons-svg";
$downloadIconHover: map-get($icons, 'download');
.icon {
  position: relative;
  width: rem(28);
  height: rem(28);
  &:before {
    position: relative;
    margin-left: -1px;
    background-image: url($downloadIcon);
    background-size: 90% 90%;
  }
}
.hover {
  cursor: pointer;
  &:hover,
  &:active {
    &:before {
      background-image: url($downloadIconHover);
    }
  }
}
</style>
